module.exports = __webpack_public_path__ + "static/media/cpg_katepersonaicon.824bdacf.png";